import {
	Dialog,
	TextField,
	DialogContent,
	DialogActions,
	DialogContentText,
	Typography,
	Button,
	Box,
} from '@material-ui/core';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DrawerTransitionSetting } from '../../../config/utils';
import { AdminAlertUnsavedIcon } from '../../../config/svg/CommonSvgIcon';
import { ErrorIcon } from '../../../config/svg/formElementIcons';

export const DialogComponent: React.FC<any> = (props: any) => {
	const {
		message,
		handleConfirmClick,
		matchString,
		handleCloseModal,
		modalOpen,
		module,
		isCancel,
		headingText,
		subHeading,
		dialogFor = '',
		confirmMsg = '',
		threeButtonText = { first: '', second: '', third: '' },
	} = props;
	const [userInputValue, setInputValue] = React.useState<string>('');
	const { t } = useTranslation();
	const [errorMessage, setErrorMessage] = React.useState<any>('');

	React.useEffect(() => {
		return () => {
			setErrorMessage('');
			setInputValue('');
		};
	}, [modalOpen]);

	const handleUserConfirmation = () => {
		if (userInputValue.toLowerCase() === matchString.toLowerCase()) {
			handleConfirmClick();
		} else {
			setErrorMessage(`Incorrect input! Please type ${matchString}.`);
		}
	};

	const getButtonText = (type: any) => {
		if (dialogFor === 'unlockUsers') {
			return type === 1 ? t('unlockLabel') : t('cancelBtn');
		} else if (module === 'information') {
			return type === 1 ? t('noLabel') : t('yesLabel');
		} else if (module === 'confirmation') {
			return type === 1 ? t('delete') : t('cancelBtn');
		} else if (module === 'defaultKR') {
			return type === 1 ? 'Change' : t('cancelBtn');
		} else if (module === 'threeButtons') {
			if (type === 1) return threeButtonText.first || 'First';
			if (type === 2) return threeButtonText.second || 'Second';
			if (type === 3) return threeButtonText.third || 'Third';
		}
	};

	return (
		<React.Fragment>
			<Dialog
				className={`default-dialog ${module === 'confirmation' || module === 'defaultKR' ? 'delete-dialog-box' : ''} ${
					module === 'threeButtons' ? 'three-button-dialog-box' : ''
				}`}
				open={modalOpen}
				transitionDuration={DrawerTransitionSetting}
				onClose={handleCloseModal}
			>
				<DialogContent>
					<AdminAlertUnsavedIcon />
					{module === 'information' ? (
						<DialogContentText
							id='alert-dialog-slide-description'
							dangerouslySetInnerHTML={{ __html: message }}
						></DialogContentText>
					) : module === 'threeButtons' ? (
						<Box className='three-buttons-dialog'>
							<Box className='three-buttons-text'>
								<Typography>{headingText}</Typography>
								<Typography>{subHeading}</Typography>
							</Box>
						</Box>
					) : (
						<React.Fragment>
							<Box className='delete-dialog-inner'>
								<Box className='delete-confirm-text'>
									<Typography>{headingText}</Typography>
									<Typography>{subHeading}</Typography>
								</Box>
								<Box className='delete-confirm-text-field'>
									<Typography>
										{confirmMsg || t('toConfirmEnter')}
										<strong> {matchString}!</strong>
									</Typography>

									<TextField
										value={userInputValue}
										name='deleteInput'
										error={errorMessage}
										helperText={
											errorMessage && (
												<React.Fragment>
													<ErrorIcon />
													{errorMessage}
												</React.Fragment>
											)
										}
										onChange={(e) => {
											setInputValue(e.target.value);
											setErrorMessage('');
										}}
										className='helperText-bottom'
									/>
								</Box>
							</Box>
						</React.Fragment>
					)}
				</DialogContent>
				<DialogActions>
					{!isCancel ? (
						<React.Fragment>
							{module === 'confirmation' || module === 'defaultKR' ? (
								<React.Fragment>
									<Button className='btn-link' onClick={handleUserConfirmation}>
										{getButtonText(1)}
									</Button>
									<Button className='btn-primary' onClick={(e) => handleCloseModal(e, 1)}>
										{getButtonText(2)}
									</Button>
								</React.Fragment>
							) : module === 'threeButtons' ? (
								<Box className='three-button-dialog-actions'>
									<Box className='dialog-actions-top'>
										<Button className='btn-link' onClick={() => props.onSecond && props.onSecond()}>
											{getButtonText(2)}
										</Button>
										<Button className='btn-link' onClick={() => props.onThird && props.onThird()}>
											{getButtonText(3)}
										</Button>
									</Box>
									<Button className='btn-primary' onClick={() => props.onFirst && props.onFirst()}>
										{getButtonText(1)}
									</Button>
								</Box>
							) : (
								<React.Fragment>
									<Button className='btn-link' onClick={(e) => handleCloseModal(e, 2)}>
										{getButtonText(1)}
									</Button>
									<Button className='btn-primary' onClick={(e) => handleCloseModal(e, 1)}>
										{getButtonText(2)}
									</Button>
								</React.Fragment>
							)}
						</React.Fragment>
					) : (
						<Button className='btn-primary' onClick={(e) => handleCloseModal(e, 2)}>
							{t('okLabel')}
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};
